/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Product_NameInputs */

const en_audit_product_name = /** @type {(inputs: Audit_Product_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Name`)
};

const es_audit_product_name = /** @type {(inputs: Audit_Product_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del Producto`)
};

/**
* | output |
* | --- |
* | "Product Name" |
*
* @param {Audit_Product_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_product_name = /** @type {((inputs?: Audit_Product_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Product_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_product_name(inputs)
	return es_audit_product_name(inputs)
});